import { cn } from "@babackapp/ui/lib/utils";
import { Column, Img, Row } from "@react-email/components";
import { logoSizeMap } from "./index";
import type { LogoBlockProps, LogoSize } from "./types";


export function LogoEmailRenderer({ block, shop }: LogoBlockProps) {
  const alignment = block.alignment || "center";
  const size: LogoSize = block.properties?.size || "medium";
  const heightPx = logoSizeMap[size] || 18;

  return (
    <Row>
      <Column
        className={cn({
          "text-left": alignment === "left",
          "text-center": alignment === "center",
          "text-right": alignment === "right",
        })}
      >
        <Img
          src={
            shop.logoUrl ??
            `https://baback-public-logos.s3.eu-north-1.amazonaws.com/${shop.logoId}`
          }
          alt={`${shop.name} Logo`}
          style={{
            height: `${heightPx}px`,
          }}
          height={heightPx}
          className={cn("block", `h-[${heightPx}px]`, {
            "mx-auto": alignment === "center",
            "ml-auto": alignment === "right",
            "mr-auto": alignment === "left",
          })}
        />
      </Column>
    </Row>
  );
}
